
import Alert from 'vux/src/components/alert/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {eventBus} from './eventbus'
export default {
name: 'App',
components: {Alert, Toast},
data () {
return {
showLoading: false,
showAuthExpire: false,
loadingText: '',
position: 'bottom',
showPositionValue: false,
errorText: ''
}
},
mounted () {

eventBus.$on('showLoading', (isShow, loadingText) => {
if (loadingText !== undefined) {
this.loadingText = loadingText
} else {
this.loadingText = '加载中'
}
this.showLoading = isShow
})

eventBus.$on('showAuthExpire', () => {
this.showAuthExpire = true
setTimeout(() => {
this.showAuthExpire = false
}, 3000)
})

eventBus.$on('showToast', (content) => {
this.showPositionValue = true
this.errorText = content
})
},
watch: {
'$route': 'canScalable'
},
methods: {
authExpire () {

this.$router.replace({
path: '/login'
})
},
canScalable () {

if (this.$route.name === 'reportdetail') {
document.querySelector('meta[name=viewport]').setAttribute('content', 'width=device-width,initial-scale=1.0,maximum-scale=3.0,minimum-scale=1.0,user-scalable=yes')
} else {
document.querySelector('meta[name=viewport]').setAttribute('content', 'width=device-width,initial-scale=1.0,maximum-scale=1.0,minimum-scale=1.0,user-scalable=no')
}
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue